const supportedMarkets = {
  americas: {
    PR: ['es', 'en'],
    DO: ['es', 'en'],
    US: ['en', 'es'],
    CA: ['en', 'fr'],
    MX: ['es', 'en'],
    CO: ['es', 'en'],
  },
  europe: {
    AT: ['de', 'en', 'fr'],
    BE: ['fr', 'en', 'de'],
    DE: ['de', 'en', 'fr'],
    DK: ['en', 'de', 'fr'],
    FR: ['fr', 'en', 'de'],
    HU: ['en', 'de', 'fr'],
    IT: ['en', 'de', 'fr'],
    LU: ['de', 'fr', 'en'],
    NO: ['en', 'de', 'fr'],
    PL: ['en', 'de', 'fr'],
    IE: ['en'],
    ES: ['en', 'de', 'fr'],
    SE: ['en', 'de', 'fr'],
    NL: ['de', 'fr', 'en'],
    CZ: ['en'],
  },
} as const

const unsupportedMarkets = {
  americas: {
    JM: ['en'],
  },
  europe: {
    TR: ['en'],
    GB: ['en'],
    CH: ['de', 'fr', 'en'],
  },
  asia_pacific: {
    AU: ['en', 'de', 'fr'],
    JP: ['ja'],
    NZ: ['en'],
    PH: ['en'],
    BN: ['en'],
    MY: ['en'],
    SG: ['en'],
    KH: ['km', 'en'],
    MN: ['mn', 'en'],
    TW: ['en'],
    HK: ['en'],
    KR: ['ko', 'en'],
    MM: ['ar', 'en'],
    TH: ['th', 'en'],
    IN: ['en'],
    ID: ['id', 'en'],
    LA: ['lo', 'en'],
  },
  middle_east_and_africa: {
    KW: ['ar', 'en'],
    LB: ['ar', 'en'],
    DZ: ['ar', 'fr', 'en'],
    KE: ['en'],
    MA: ['ar', 'fr', 'en'],
    OM: ['en'],
    SA: ['en'],
    UE: ['en'],
    EG: ['en'],
    JO: ['en'],
  },
} as const

export const countryRoutes = {
  UE: 'uae',
  AT: 'aut',
  AU: 'aus',
  BE: 'bel',
  BN: 'brn',
  CA: 'can',
  CZ: 'cze',
  CH: 'che',
  CO: 'col',
  DE: 'deu',
  DK: 'dnk',
  DO: 'dom',
  DZ: 'dza',
  EG: 'egy',
  ES: 'esp',
  FI: 'fin',
  FR: 'fra',
  GB: 'gbr',
  HK: 'hkg',
  HU: 'hun',
  ID: 'idn',
  IE: 'irl',
  IN: 'ind',
  IT: 'ita',
  JM: 'jam',
  JO: 'jor',
  JP: 'jpn',
  KE: 'ken',
  KH: 'khm',
  KR: 'kor',
  KW: 'kwt',
  LA: 'lao',
  LB: 'lbn',
  MA: 'mar',
  MM: 'mmr',
  MN: 'mng',
  MX: 'mex',
  MY: 'mys',
  NL: 'nld',
  NO: 'nor',
  NZ: 'nzl',
  OM: 'omn',
  PH: 'phl',
  PL: 'pol',
  PR: 'pri',
  SE: 'swe',
  SG: 'sgp',
  TH: 'tha',
  TR: 'tur',
  TW: 'twn',
  UA: 'ukr',
  US: 'usa',
  VN: 'vnm',
  LU: 'lux',
  SA: 'sau',
} as const

export const languageTranslations = {
  ar: 'العربية',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  id: 'Indonesia',
  ja: '日本語',
  km: 'Khmer',
  ko: '한국어',
  tr: 'Türkçe',
  vi: 'Tiếng Việt',
  zh: '中文',
  mn: 'монгол',
  lo: 'ພາສາລາວ',
  th: 'ไทย',
  nl: 'Nederlands',
  it: 'Italiano',
} as const

const developmentMarkets = {
  asia_pacific: {},
  europe: {},
  middle_east_and_africa: {},
  americas: {},
} as const

/**
 *
 * @returns  {Object} Picker regions
 */
export const getPickerRegions = () => ({
  americas: {
    ...supportedMarkets.americas,
    ...developmentMarkets.americas,
    ...unsupportedMarkets.americas,
  },
  europe: {
    ...supportedMarkets.europe,
    ...developmentMarkets.europe,
    ...unsupportedMarkets.europe,
  },
  asia_pacific: {
    ...developmentMarkets.asia_pacific,
    ...unsupportedMarkets.asia_pacific,
  },
  middle_east_and_africa: {
    ...developmentMarkets.middle_east_and_africa,
    ...unsupportedMarkets.middle_east_and_africa,
  },
})

/**
 *
 * @returns {Object} Flattened supported country list
 */
export const getFlattenedCountryList = () => ({
  ...supportedMarkets.americas,
  ...supportedMarkets.europe,
})
